
export const {
    PORT,
    REACT_APP_NAME_APP,
    REACT_APP_ID_SERVICE,
    REACT_APP_ID_TEMPLATE,
    REACT_APP_ID_USER
 } = process.env;